export default {"src":"/_next/static/media/lightningCloud_24.1f594d40.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};